import { DecimalPipe, NgClass } from '@angular/common';
import { Component, input, OnInit, output } from '@angular/core';
import { FlightsData } from '../../../models/api/flight';
import { PassengerType } from '../../../enums';

@Component({
  selector: 'app-fare-reselect',
  templateUrl: './fare-reselect.component.html',
  standalone: true,
  imports: [DecimalPipe, NgClass],
})
export class FareReselectComponent implements OnInit {
  readonly item = input<FlightsData>();
  readonly isSelecting = input<boolean>(false);
  readonly disabled = input<boolean>(false);
  readonly selected = output<FlightsData>();

  constructor() {}

  ngOnInit(): void {}

  flightFareClass(flight: FlightsData) {
    return flight.segments
      .map((s) => s.fareClass)
      .filter((obj, index, self) => index === self.findIndex((t) => t === obj))
      .join(', ');
  }

  flightGroupClass(flight: FlightsData) {
    return flight.segments
      .map((s) => s.groupClass)
      .filter((obj, index, self) => index === self.findIndex((t) => t === obj))
      .join(', ');
  }

  fareOriginalPrice(flight: FlightsData) {
    const defaultPrice = flight.prices.find(
      (p) => p.type === PassengerType.Adult,
    );
    if (defaultPrice && defaultPrice.discount > 0) {
      return (
        defaultPrice.price +
        defaultPrice.tax +
        defaultPrice.fee +
        defaultPrice.discount
      );
    }
    return 0;
  }

  farePrice(flight: FlightsData) {
    const defaultPrice = flight.prices.find(
      (p) => p.type === PassengerType.Adult,
    );
    if (defaultPrice) {
      return defaultPrice.price + defaultPrice.tax + defaultPrice.fee;
    }
    return 0;
  }

  onSelectFlight(flight: FlightsData): void {
    if (!this.disabled()) {
      this.selected.emit(flight);
    }
  }
}
